/* @flow */
import * as React from 'react';
import { createTheme } from '@mui/material/styles';
import type { Theme } from '../../types/themeTypes';

export default function useMuiCreateTheme(theme: Theme) {
  const MuiTheme = React.useMemo(
    () =>
      createTheme({
        braindate: theme,
        palette: {
          primary: { main: theme.accentColor },
          mode: theme.name,
          success: {
            light: '#006239',
            main: '#00BC4B',
            dark: '#006239',
          },
        },
        components: {
          MuiPopover: {
            defaultProps: {
              disableScrollLock: true,
            },
            styleOverrides: {
              paper: {
                borderRadius: 14,
              },
            },
          },
          MuiMenu: {
            defaultProps: {
              disableScrollLock: true,
            },
          },
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: 12,
              },
            },
          },
          MuiSelect: {
            defaultProps: {
              variant: 'outlined',
            },
            styleOverrides: {
              nativeInput: {
                display: 'none',
              },
            },
          },
          MuiDrawer: {
            defaultProps: {
              disableDiscovery: true,
              disableSwipeToOpen: true,
            },
            styleOverrides: {
              paper: {
                paddingTop: 24,
                borderTopLeftRadius: 18,
                borderTopRightRadius: 18,

                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 16,
                  left: 'calc(50% - 11px)',
                  width: 38,
                  height: 4,
                  backgroundColor: theme.calendarDisableButtonBackgroundColor,
                },
              },
            },
          },
        },
        shape: {
          borderRadius: 8,
        },
        typography: {
          fontFamily: theme.baseFontFamily,
        },
      }),
    [theme],
  );
  return MuiTheme;
}
